import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { MuiBox, MuiTypography } from "../../../../../../components";
import { COLORS } from "../../../../../../styles/constants.style";
import { CoachMetricsCardTypes } from "../../../../modelsAndSchemas/Models";
import { CPDashboardCoachMetricsCardWrapper } from "./CPDashboardCoachMetricsCard.style";

export interface CPDashboardCoachMetricsCardProps {
  type: CoachMetricsCardTypes;
  value: string;
  onCardClick: () => void;
  header: string;
  label: string;
  topIcon: React.ReactNode;
  showArrow?: boolean;
  labelSecondary?: string;
  valueSecondary?: string;
}

export const CPDashboardCoachMetricsCard = ({
  topIcon,
  header,
  label,
  value,
  type,
  onCardClick,
  showArrow,
  labelSecondary,
  valueSecondary,
}: CPDashboardCoachMetricsCardProps) => {
  return (
    <CPDashboardCoachMetricsCardWrapper onClick={onCardClick}>
      <MuiBox className="coach-metrics-card">
        <MuiBox className={`coach-metrics-card-bg-${type}`} />
        <MuiBox className="coach-metrics-card-overlay" />
        <MuiBox className="coach-metrics-data-container">
          <MuiBox className="coach-metrics-data-container-top">
            <MuiTypography
              className="coach-metrics-card-header"
              variant="h3SemiBold"
            >
              {header}
            </MuiTypography>
            <MuiBox className={`coach-metrics-card-icon-${type}`}>
              {topIcon}
            </MuiBox>
          </MuiBox>
          <MuiBox className="coach-metrics-data-container-bottom">
            <MuiBox>
              <MuiBox>
                <MuiTypography
                  variant="h5SemiBold"
                  className={`coach-metrics-card-label-${type}`}
                >
                  {label}
                </MuiTypography>
              </MuiBox>
              <MuiTypography
                className="coach-metrics-card-value"
                variant="body2Bold"
              >
                {value}
              </MuiTypography>
            </MuiBox>
            {labelSecondary && (
              <MuiBox>
                <MuiBox>
                  <MuiTypography
                    variant="h5SemiBold"
                    className={`coach-metrics-card-label-${type}`}
                  >
                    {labelSecondary}
                  </MuiTypography>
                </MuiBox>
                <MuiTypography
                  className="coach-metrics-card-value"
                  variant="body2Bold"
                >
                  {valueSecondary}
                </MuiTypography>
              </MuiBox>
            )}
            <MuiBox>
              {showArrow && (
                <ArrowForwardRoundedIcon htmlColor={COLORS.cirrus_white} />
              )}
            </MuiBox>
          </MuiBox>
        </MuiBox>
      </MuiBox>
    </CPDashboardCoachMetricsCardWrapper>
  );
};
